import { useState } from 'react'

const useImage = () => {
    const [loading, setLoading] = useState<boolean>(true)
    const [error, setError] = useState<boolean>(false)

    return {
        loading,
        setLoading,
        error,
        setError
    }
}

export default useImage
